import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { PatientsystemexaminationData, PatientsystemexaminationMst } from '../../../interfaces/masters/patientsystemexamination';
import { PatientsystemexaminationApi } from '../api/patientsystemexamination.api';


@Injectable()
export class PatientsysytemexaminationService extends PatientsystemexaminationData {

  constructor(private api: PatientsystemexaminationApi) {
    super();    
  }
  list(url: string): Observable<PatientsystemexaminationMst[]> {
    return this.api.list(url);
  }
  getById(url:string): Observable<PatientsystemexaminationMst>{
      return this.api.getById(url); 
  }
  create(url: string, data:PatientsystemexaminationMst): Observable<PatientsystemexaminationMst> {
    return this.api.add(url,data);
  }
  update(url: string, data:PatientsystemexaminationMst): Observable<PatientsystemexaminationMst> {
    return this.api.update(url,data);
  }  
  delete(url: string): Observable<boolean> { 
    return this.api.delete(url);
  } 
}
